import { render, staticRenderFns } from "./ClientBonitaPopUp.vue?vue&type=template&id=598758a6&scoped=true&"
import script from "./ClientBonitaPopUp.vue?vue&type=script&lang=js&"
export * from "./ClientBonitaPopUp.vue?vue&type=script&lang=js&"
import style0 from "./ClientBonitaPopUp.vue?vue&type=style&index=0&id=598758a6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../safari-rental/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598758a6",
  null
  
)

export default component.exports